import React,{ useEffect,useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styled from "@emotion/styled";
import TableContainer from '@mui/material/TableContainer';
import { useTranslation } from 'react-i18next';

import { Link, useNavigate } from 'react-router-dom';
import {sort} from '../../redux/slices/usersSlice'

import TitleLink from '../../components/TitleLink';
import { getUsers } from '../../api/APIServices';
import {API_STATUS, USER_TYPE} from '../../constants/index'
import NumberCircle from '../../components/NumberCircle';
import { completePercent, getStatusColor } from '../../utils/utils';
import dayjs from 'dayjs';

const TableRowStyled = styled(TableRow)`
        &:nth-of-type(odd) {
            background-color: #FFFFFF;
        }
        &:nth-of-type(even) {
            background-color: #f8f8f8;
        }
        & > td {
            color: black;
        }
        `;

const UsersBox = () => {
    const {t} = useTranslation('global');
    const navigate = useNavigate();

    const [isAsc, setIsAsc] = useState(true);
    let data=[];
    const dispatch = useDispatch();
    const {users, status} = useSelector((state)=> state.users );


    useEffect(()=>{
        dispatch(getUsers());
    },[]);

    const  sortFunction = (a,b) => {  
        var dateA = new Date(a.enrollmentDate).getTime();
        var dateB = new Date(b.enrollmentDate).getTime();
        return dateA < dateB ? 1 : -1;  
    };

    //SORT DATA
    const sortBy = (sortField='id', isAsc) =>{
        setIsAsc(!isAsc);
        let element = 'users'
        dispatch(sort({data, sortField, isAsc, element}));
    }
    //dont show clinicain user in the list
    let updatedUsers = users.filter((user) => user.userType !== USER_TYPE.CLINICIAN)
    data = [...updatedUsers].sort(sortFunction);

    const showUserDetails = (userId) => {
        navigate(`/user_details/${userId}`);
    }

   
    return (
   <>
        <div className='full-container'>
            <TitleLink
                boxTitle={t('users')}
                subTitle={t('lable_sort_list')}
                enableLink={false}
            />  
           
            <TableContainer sx={{ 
                maxHeight: 630,
               
                "& .MuiTableCell-root": {
                    border: '1px solid #f3f3f3'
                  },
                "&::-webkit-scrollbar": {
                    width: 6
                },
                "&::-webkit-scrollbar-track": {
                    backgroundColor: "white"
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#ccc",
                    borderRadius: 2
                },
            }}>
            <Table size="small" stickyHeader aria-label="sticky table">
                <TableHead sx={{
                    "& th": {
                    backgroundColor: "#def1fc",
                    color: "black",
                    fontWeight:600,
                    },
                    "& th:hover": {
                    backgroundColor: "#c9e8fa",
                    }
                }}>
                    <TableRow>
                        <TableCell align="center" colSpan={3}>&nbsp;</TableCell>
                        <TableCell align="center" colSpan={4}>{t('improvement')}(%)</TableCell>
                        <TableCell align="center" colSpan={3}>{t('compliance')}(%)</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell  onClick={()=>sortBy('firstName', isAsc)} align="left">{t('first_name')}</TableCell>
                        <TableCell  onClick={()=>sortBy('lastName', isAsc)} align="left">{t('last_name')}</TableCell>
                        <TableCell align="left">{t('enrollment_date')}</TableCell>
                        
                        <TableCell sortDirection="asc">{t('tug')}</TableCell>
                        <TableCell align="left">{'STS'}</TableCell>
                        <TableCell>{t('pain')}</TableCell>
                        <TableCell align="left">{t('sane')}</TableCell>
                        
                        <TableCell align="left">{t('education')}</TableCell>
                        <TableCell align="left">{t('exercise')}</TableCell>
                        <TableCell align="left">{t('questionnaire')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data && data.length > 0 && data.map(user => (
                        <TableRowStyled onClick={()=>showUserDetails(user.userId)} key={user.userId}>
                            <TableCell align="left">
                                <Link style={{ color: '#028DD5', textDecoration: 'inherit'}} 
                                   
                                > 
                                    {user.firstName}
                                </Link>
                            </TableCell>
                            <TableCell align="left">
                                <Link style={{ color: '#028DD5', textDecoration: 'inherit'}} 
                                  
                                > 
                                    {user.lastName}
                                </Link>
                            </TableCell>
                            <TableCell align="left">
                            {dayjs(user.enrollmentDate).format('MM/DD/YYYY')}

                            </TableCell>
                            <TableCell component="th" scope="row">
                               
                                </TableCell>
                            <TableCell align="left">
                               
                            </TableCell>
                            <TableCell align="left">
                               
                            </TableCell>
                            <TableCell align="left">
                              
                            </TableCell>
                            <TableCell align="left">
                               
                                <NumberCircle  color={getStatusColor(user.compliance.education)}>
                                {completePercent(user.compliance.education)}

                                  
                                </NumberCircle>

                            </TableCell>
                            <TableCell align="left">
                              
                                <NumberCircle  color={getStatusColor(user.compliance.exercise)}>
                                   
                                    {completePercent(user.compliance.exercise)}

                                </NumberCircle>

                            </TableCell>
                            <TableCell align="left">
                               
                                <NumberCircle  color={getStatusColor(user.compliance.questionnaire)}>
                                   
                                    {completePercent(user.compliance.questionnaire)}

                                    </NumberCircle>

                            </TableCell>
                        </TableRowStyled>
                    ))}
                </TableBody>
            </Table>
            </TableContainer>
            
        </div>
    </>
    
  );
}

export default UsersBox;
